// extracted by mini-css-extract-plugin
module.exports = {"FoodPortionSelect":"FoodPortionSelect_FoodPortionSelect__2UAPy","FoodPortions":"FoodPortionSelect_FoodPortions__1pIkp","FoodPortion":"FoodPortionSelect_FoodPortion__1z_HK"};